import React from 'react';
import "./RegisterPage.css";
import "./login.css";
import { Link } from 'react-router-dom';
import Loader from "../../common/loader/containers/loader_cont";
import Snackbar from "../../common/snackbar/components/snackbar";

const Register = (props) => {
  const [formData, setFormData] = React.useState({ name: '', aadharNo: '', mobileNo: '', dob: '' });
  const [errors, setErrors] = React.useState({});
  const [submitted, setSubmitted] = React.useState(false);

  // Watch Redux snackbar — when registration succeeds, show the ack screen
  const prevRef = React.useRef(false);
  React.useEffect(() => {
    const received = props.snackbar?.response_received;
    if (received && !prevRef.current) {
      const msg = (props.snackbar?.message || '').toLowerCase();
      if (msg.includes('success') || msg.includes('logging')) {
        setSubmitted(true);
      }
    }
    prevRef.current = !!received;
  }, [props.snackbar?.response_received, props.snackbar?.message]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: '' });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Applicant name is required';
    if (!formData.aadharNo || !/^\d{12}$/.test(formData.aadharNo))
      newErrors.aadharNo = 'Aadhaar number must be exactly 12 digits';
    if (!formData.mobileNo || !/^\d{10}$/.test(formData.mobileNo))
      newErrors.mobileNo = 'Mobile number must be exactly 10 digits';
    if (!formData.dob) newErrors.dob = 'Date of Birth is required';
    return newErrors;
  };

  const handleSubmit = () => {
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) { setErrors(newErrors); return; }
    // Uses Redux action → which auto-logins after reg (see auth/actions.js)
    props.register_user(formData.name, formData.aadharNo, formData.dob, formData.mobileNo);
  };

  return (
    <div className="neet-page">
      {/* Top Bar */}
      <div className="neet-top-bar">
        Government of India &nbsp;|&nbsp; Ministry of Health and Family Welfare &nbsp;|&nbsp; National Testing Agency
      </div>

      {/* Header */}
      <div className="neet-header">
        <div className="neet-header-inner">
          <div className="neet-logo-emblem">🇮🇳</div>
          <div className="neet-header-text">
            <h1>Prayash NEET 2027 — Student Registration</h1>
            <h2>National Eligibility cum Entrance Test (Undergraduate)</h2>
            <div className="neet-subtitle">PRAYASH EDUCATION — NEW CANDIDATE REGISTRATION</div>
          </div>
        </div>
      </div>

      {/* Nav Bar */}
      <div className="neet-nav">
        <div className="neet-nav-inner">
          <span className="neet-nav-item">Home</span>
          <span className="neet-nav-item">Notifications</span>
          <span className="neet-nav-item active">Register</span>
          <span className="neet-nav-item">Contact</span>
        </div>
      </div>

      {/* Main */}
      <div className="neet-register-main">
        <div className="neet-register-card">
          <div className="neet-register-card-header">
            <h3>📝 New Candidate Registration</h3>
            <p>NEET 2027 — PRAYASH EDUCATION Admission Form</p>
          </div>

          <div className="neet-register-form">
            {!submitted ? (
              <>
                <div className="neet-instructions-box">
                  <strong>📋 Instructions Before Filling the Form:</strong>
                  <ul>
                    <li>Keep your Aadhaar card ready — number must be exactly 12 digits.</li>
                    <li>Mobile number must be active (you'll need it for admit card).</li>
                    <li>Date of birth must match your 10th marksheet/birth certificate.</li>
                    <li>Once registered, you will be automatically taken to your dashboard.</li>
                  </ul>
                </div>

                <div className="neet-form-row">
                  <div className="neet-form-group">
                    <label className="neet-form-label">Applicant Name <span>*</span></label>
                    <input
                      className={`neet-form-input ${errors.name ? 'error' : ''}`}
                      type="text" name="name"
                      placeholder="Full name as per Aadhaar"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                    {errors.name && <div className="neet-error-text">{errors.name}</div>}
                  </div>

                  <div className="neet-form-group">
                    <label className="neet-form-label">Aadhaar Number <span>*</span></label>
                    <input
                      className={`neet-form-input ${errors.aadharNo ? 'error' : ''}`}
                      type="text" name="aadharNo" maxLength={12}
                      placeholder="12-digit Aadhaar number"
                      value={formData.aadharNo}
                      onChange={handleInputChange}
                    />
                    {errors.aadharNo && <div className="neet-error-text">{errors.aadharNo}</div>}
                  </div>
                </div>

                <div className="neet-form-row">
                  <div className="neet-form-group">
                    <label className="neet-form-label">Date of Birth <span>*</span></label>
                    <input
                      className={`neet-form-input ${errors.dob ? 'error' : ''}`}
                      type="date" name="dob"
                      value={formData.dob}
                      onChange={handleInputChange}
                    />
                    {errors.dob && <div className="neet-error-text">{errors.dob}</div>}
                  </div>

                  <div className="neet-form-group">
                    <label className="neet-form-label">Mobile Number <span>*</span></label>
                    <input
                      className={`neet-form-input ${errors.mobileNo ? 'error' : ''}`}
                      type="text" name="mobileNo" maxLength={10}
                      placeholder="10-digit mobile number"
                      value={formData.mobileNo}
                      onChange={handleInputChange}
                    />
                    {errors.mobileNo && <div className="neet-error-text">{errors.mobileNo}</div>}
                  </div>
                </div>

                <hr className="neet-divider" />

                <button className="neet-register-btn" onClick={handleSubmit}>
                  Register & Continue →
                </button>

                <div className="neet-login-link">
                  Already registered? <Link to="/">Login Here</Link>
                </div>
              </>
            ) : (
              /* ── ACKNOWLEDGEMENT SCREEN ── */
              <div style={{ textAlign: 'center', padding: '10px 0' }}>

                {/* Mission Badge */}
                <div style={{
                  background: '#000', borderRadius: '12px', padding: '18px 24px',
                  marginBottom: '24px', border: '2px solid #9dde59'
                }}>
                  <div style={{ color: '#9dde59', fontWeight: 900, fontSize: '18px', letterSpacing: '2px' }}>
                    PRAYASH MISSION NEET 2027
                  </div>
                  <div style={{ color: '#fff', fontSize: '12px', marginTop: '4px', opacity: 0.8 }}>
                    Empowering Students. Transforming Futures.
                  </div>
                </div>

                {/* Success Icon */}
                <div style={{
                  width: '72px', height: '72px', borderRadius: '50%',
                  background: '#9dde59', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', margin: '0 auto 16px', fontSize: '36px'
                }}>✅</div>

                <h4 style={{ color: '#1a3a6b', fontSize: '20px', margin: '0 0 8px' }}>
                  Registration Successful!
                </h4>

                <p style={{ color: '#444', marginBottom: '20px', lineHeight: 1.6 }}>
                  Welcome to <strong>Prayash Mission NEET 2027</strong>.<br />
                  <strong>{formData.name}</strong>, you are now registered.<br />
                  Aadhaar: <strong>{formData.aadharNo}</strong>
                </p>

                {/* Info box */}
                <div style={{
                  background: '#f0fce8', border: '1px solid #9dde59', borderRadius: '8px',
                  padding: '14px 18px', textAlign: 'left', marginBottom: '20px', fontSize: '13px', color: '#333'
                }}>
                  <div style={{ fontWeight: 700, marginBottom: '8px', color: '#000' }}>
                    📋 Next Steps:
                  </div>
                  <ul style={{ margin: 0, paddingLeft: '18px', lineHeight: 2 }}>
                    <li>You are being redirected to your dashboard automatically.</li>
                    <li>Complete your profile — all 4 steps are required.</li>
                    <li>Upload your Passport Photo, Aadhaar card, and Signature.</li>
                    <li>Submit the form to receive your Acknowledgement PDF.</li>
                  </ul>
                </div>

                {/* Spinner — auto-login is happening in background */}
                <div style={{ color: '#666', fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                  <span style={{ display: 'inline-block', width: '16px', height: '16px', border: '3px solid #9dde59', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }}></span>
                  Logging you in...
                </div>

                <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="neet-footer">
        © 2027 PRAYASH EDUCATION | NEET 2027 Candidate Portal | All Rights Reserved<br />
        <a href="#">Privacy Policy</a> | <a href="#">Terms of Use</a> | <a href="#">Help & FAQ</a>
      </div>

      <Loader />
      <Snackbar
        open={props.snackbar.response_received}
        close_snack_bar={props.close_snack_bar}
        message={props.snackbar.message}
      />
    </div>
  );
};

export default Register;